import React, { Component } from 'react'
import { connect } from 'react-redux'
import DuplicateAndEditLocationSelection from '../../components/modals/DuplicateAndEditLocationSelection'
import {addCopyToRepo} from '../../utils/addCopyToRepo'
import {copyItemFromRepoEvent} from '../../utils/analytics/copyItemFromRepoEvent'
import {showNotification} from '../../actions/notifications'
import sortBy from 'lodash/sortBy'
import filter from 'lodash/filter'
 

class DuplicateAndEditModalContainer extends Component {

	constructor(){
		super()
		this.selectLocation=this.selectLocation.bind(this)

		this.state={
			submitLoading: false,
			selectedRepoId:null,
			librarySelected:false
		}

	}

	componentDidMount(){
		if(window.analytics){
			window.analytics.page('Duplicate and edit modal')
		}
	}

	selectLocation(repoId,librarySelected){
		this.setState({submitLoading:true,selectedRepoId:repoId,librarySelected:librarySelected})
		const {itemToDuplicate}=this.props
		return this.props.addCopyToRepo(itemToDuplicate,repoId).then((response)=>{
			window.open(`/seteditor/${response.id}`,'_blank')
			if(window.analytics){
				window.analytics.track('Duplicate and edit success')

				copyItemFromRepoEvent(itemToDuplicate,'Set Editor')

			}
			this.props.hideModal()
		})

	} 


	render() {
		return (    
			<DuplicateAndEditLocationSelection 
				submitLoading={this.state.submitLoading}
				selectedRepoId={this.state.selectedRepoId}
				repos={this.props.repos} 
				item={this.props.itemToDuplicate} 
				hideModal={this.props.hideModal} 
				selectLocation={this.selectLocation}
				librarySelected={this.state.librarySelected}
			/>
		)
	}
}


export default connect(
	(state) => ({
		repos:sortBy(filter(state.repos, function(repo) { 
    		if((!repo.published && !repo.disabled  && repo.role!=='viewer' && repo.joined) || (repo.published && repo.role==='author')){
    			return repo
    		}
 			}),
		[repo => repo.name.toLowerCase()]),
		itemToDuplicate:state.modals.itemToDuplicate,


	}),
	{ addCopyToRepo,showNotification}
)(DuplicateAndEditModalContainer)

